import React from 'react'
import unauthorisedImg from '../../assets/images/401@2x.png'

function Unauthorised() {
  return (
    <div>
      <div className='img-center-page'>
        <img src={unauthorisedImg} />
      </div>
      <div class="btn-fix-btm">
        {/* <button class="drk-blue-btn">Back to Home</button> */}
      </div>
    </div>
  )
}

export default Unauthorised